import { EUserGroup } from '../enums/group.enum';
import { OptionDescription } from './option.type';

type TUserGroup = Exclude<EUserGroup, EUserGroup.PROJECT | EUserGroup.SETTINGS>;
export type UserGroupOption = OptionDescription<TUserGroup> & { accessible: boolean; total: number };
export type UserGroupRecord = Record<TUserGroup, UserGroupOption>;
